
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';

import { ConsumidorService } from './restrito/consumidor/shared';
import { EnderecoService } from './shared/endereco/endereco.service';
import { AreaParticipacaoService, GenericHttpService, MunicipioService, ParametrosService } from './shared';
import { AuthGuard } from './restrito/guard/auth.guard';
import { LoginService } from './restrito/consumidor/shared/login.service';
import { InstituicaoService } from './restrito/instituicao/shared';

import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

import { SharedLayoutModule } from './shared-layout/shared-layout.module';
import { AppRoutingModule } from './app.routing.module';

import localePt from '@angular/common/locales/pt';
import { SorteioService } from './publico/sorteios/index';
import { EtapaService } from './shared/service/etapa.service';
import { OndadoveraoComponent } from './publico/ondadoverao/ondadoverao.component';
import { ModalService } from './publico/ondadoverao/modal-service.service';
import { LoadingService } from './shared-layout/loading/loading.service';
import { LoadingComponent } from './shared-layout/loading/loading.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';;
import { ReactiveFormsModule } from '@angular/forms';
import { SessionStorageSorteio } from './publico/sorteios/shared/session-storage-sorteio';
import { TipoResponsabilidadeRepresentanteLegalService } from './shared/service/tipo-responsabilidade-representante-legal.service';
import { LinkResourcesService } from './restrito/consumidor/shared/link-resources-service';
import { YoutubeService } from './shared/service/youtube.service';
import { DemonstrativoImpostoRendaService } from './shared/service/demonstrativo-imposto-renda.service';
import { ConsumidorTermoLgpdService } from './restrito/consumidor/shared/consumidor-termo-lgpd-service';
import { CadastroSenhaCidadaoService } from './shared/service/cadastro-senha-cidadao.service';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent,
    OndadoveraoComponent,
    LoadingComponent
  ],
  imports: [
    BrowserModule,
    environment.production ? ServiceWorkerModule.register('/sistemas/nbpp/ngsw-worker.js') : [],
    AppRoutingModule,
    SharedLayoutModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    InstituicaoService,
    ConsumidorService,
    EnderecoService,
    GenericHttpService,
    AuthGuard,
    MunicipioService,
    AreaParticipacaoService,
    LoginService,
    ParametrosService,
    SorteioService,
    EtapaService,
    LoadingService,
    ModalService,
    SessionStorageSorteio,
    LinkResourcesService,
    TipoResponsabilidadeRepresentanteLegalService,
    YoutubeService,
    DemonstrativoImpostoRendaService,
    ConsumidorTermoLgpdService,
    CadastroSenhaCidadaoService
    // O pipe currency com BRL estava usando 0,000.00. Corrigido mudando a localidade para pt-BR.
    ,{ provide: LOCALE_ID, useValue: 'pt-BR' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts